import { combineReducers } from "redux";
import { AuthReducer, AuthState } from "./AuthReducer";
import NotificationReducer, { NotificationsState } from "./NotificationsReducer";
import UsersReducer, { UsersState } from "./UsersReducer";
import MiscReducer, { MiscState } from "./MiscReducer";
import ExercisesReducer, { ExercisesState } from "./ExercisesReducer";
import ProgramsReducer, { ProgramsState } from "./ProgramsReducer";

export interface ReduxState {
    auth: AuthState;
    notifications: NotificationsState;
    users: UsersState;
    exercises: ExercisesState;
    programs: ProgramsState;
    misc: MiscState;
}

export type GetStateFunction = () => ReduxState;
export type DispatchFunction = (action: { type: string, payload: any }) => void;

export const reducers: any = combineReducers({
    auth: AuthReducer,
    notifications: NotificationReducer,
    users: UsersReducer,
    exercises: ExercisesReducer,
    programs: ProgramsReducer,
    misc: MiscReducer,
});